/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {internalUpdateAliasNotificationSettingsBackfill} from '../api'

export const useMutationInternalUpdateAliasNotificationSettingsBackfill = createReactQueryMutationHook('internalUpdateAliasNotificationSettingsBackfill', internalUpdateAliasNotificationSettingsBackfill)
